import type { WorkflowEventResponse } from './api';
import type { ArtifactType, WorkflowArtifact } from './types';

const VALID_ARTIFACT_TYPES: ReadonlySet<string> = new Set([
  'pr',
  'commit',
  'file_created',
  'file_modified',
  'branch',
]);

function toArtifactType(value: unknown): ArtifactType {
  return typeof value === 'string' && VALID_ARTIFACT_TYPES.has(value)
    ? (value as ArtifactType)
    : 'file_created';
}

export function artifactEventsFromWorkflowEvents(
  events: readonly WorkflowEventResponse[]
): WorkflowArtifact[] {
  const artifacts: WorkflowArtifact[] = [];
  for (const event of events) {
    if (event.event_type !== 'workflow_artifact') continue;
    const data = event.data;
    const artifact = {
      type: toArtifactType(data.artifactType),
      label: typeof data.label === 'string' ? data.label : '',
      url: typeof data.url === 'string' ? data.url : undefined,
      path: typeof data.path === 'string' ? data.path : undefined,
    };
    if (artifact.label || artifact.url || artifact.path) {
      artifacts.push(artifact);
    }
  }
  return artifacts;
}

function artifactKey(artifact: WorkflowArtifact): string {
  if (artifact.path) return `path:${artifact.path}`;
  if (artifact.url) return `url:${artifact.url}`;
  return `label:${artifact.type}:${artifact.label}`;
}

export function mergeWorkflowArtifactSources(
  ...sources: readonly (readonly WorkflowArtifact[])[]
): WorkflowArtifact[] {
  const seen = new Set<string>();
  const merged: WorkflowArtifact[] = [];
  for (const source of sources) {
    for (const artifact of source) {
      const key = artifactKey(artifact);
      if (seen.has(key)) continue;
      seen.add(key);
      merged.push(artifact);
    }
  }
  return merged;
}
